/**
 * Created by andrey on 12.02.2021.
 */

const BonusWorkerWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.state = cleverapps.adsLimits.state(AdsLimits.TYPES.WORKER);

        if (Map2d.currentMap.workers.isBonusWorkerBuyed() || Map2d.currentMap.workers.countRegularTotal() > Map2d.currentMap.workers.countRegularLimit()) {
            this.state = BonusWorkerWindow.STATE_BUYED;
        }

        Map2d.currentMap.workers.wantsToShowBonusWorkerWindow = false;

        this._super({
            name: "BonusWorkerWindow",
            title: Messages.get("BonusWorkerWindow.title"),
            content: this.createContent(),
            noBackground: true,
            notCloseByTouchInShadow: true,
            closeButtonDelay: true
        });

        cleverapps.rewardedAdsManager.onRewardedRefresh(() => {
            if (this.watchButton) {
                const watchButton = this.createWatchButton(Product.FormatTimePeriod(Workers.ADS_BONUS_WORKER_PERIOD, true).title);
                watchButton.setAlignment(this.watchButton);
                this.watchButton.parent.addChild(watchButton);
                this.watchButton.removeFromParent();
                this.watchButton = watchButton;
            }
        }, this);

        cleverapps.paymentsLogic.onChangeStatus(this.updateButton.bind(this), this);

        cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");

        Map2d.currentMap.workers.onWorkerPurchaseFinished = this.createListener((success) => {
            if (success) {
                this.close();
            } else {
                this.updateButton();
            }
        });
    },

    updateButton: function () {
        if (this.button) {
            this.button.setString(Map2d.currentMap.workers.getPriceTag());

            if (Map2d.currentMap.workers.getProduct().isAvailable()) {
                this.button.enable();
            } else {
                this.button.disable();
            }
        }
    },

    getPerson: function () {
        return {
            role: cleverapps.config.ui === "heroes" ? "worker" : "narrator",
            skin: cleverapps.skins.getSlot("bonusWorkerPersonSkin")
        };
    },

    createInfoBlock: function () {
        const styles = cleverapps.styles.BonusWorkerWindow.infoBlock;

        let infoText;
        switch (this.state) {
            case AdsLimits.STATE_UNAVAILABLE:
            case AdsLimits.STATE_NOT_LOADED:
            case AdsLimits.STATE_DISABLED:
                infoText = cleverapps.UI.generateOnlyText(Messages.get("BonusWorkerWindow.buy.info.text"), cleverapps.styles.FONTS.BONUS_WORKER_WINDOW_INFO_TEXT);
                break;

            case AdsLimits.STATE_LIMITED:
            case AdsLimits.STATE_READY:
                infoText = cleverapps.UI.generateOnlyText(Messages.get("BonusWorkerWindow.ads.info.watch"), cleverapps.styles.FONTS.BONUS_WORKER_WINDOW_INFO_TEXT);
                break;

            case BonusWorkerWindow.STATE_BUYED:
                infoText = cleverapps.UI.generateOnlyText(Messages.get("BonusWorkerWindow.buyed.info.text"), cleverapps.styles.FONTS.BONUS_WORKER_WINDOW_INFO_TEXT);
                break;
        }

        infoText.setDimensions(styles.width, 0);
        infoText.fitTo(undefined, styles.height);
        infoText.setDimensions(styles.width, styles.height);
        infoText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        infoText.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);

        return infoText;
    },

    createTimer: function () {
        const styles = cleverapps.styles.BonusWorkerWindow.timer;

        const countDown = new cleverapps.CountDown(Map2d.currentMap.workers.bonusWorkerLeftTime());

        return new cleverapps.CountDownView(countDown, {
            font: cleverapps.styles.FONTS.BONUS_WORKER_WINDOW_TIMER_TEXT,
            background: {
                frame: bundles.big_timer.frames.big_timer_bg_png,
                width: styles.width,
                height: styles.height
            },
            icon: {
                json: bundles.big_timer.jsons.big_timer_json,
                animation: "animation"
            }
        });
    },

    createBuyButton: function (title) {
        const styles = cleverapps.styles.BonusWorkerWindow.button;

        this.button = new cleverapps.UI.Button({
            text: Map2d.currentMap.workers.getPriceTag(),
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                Map2d.currentMap.workers.buyBonusWorker();
            }
        });

        this.updateButton();

        if (title) {
            title = cleverapps.UI.generateOnlyText(Messages.get(title), cleverapps.styles.FONTS.BONUS_WORKER_WINDOW_BUTTON_TITLE_TEXT);
            cleverapps.UI.fitToBox(title, {
                width: this.button.width,
                height: title.height
            });
        }

        return new cleverapps.Layout([this.button, title], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createWatchButton: function (text, timeLeft) {
        const styles = cleverapps.styles.BonusWorkerWindow.button;

        const disabled = timeLeft || cleverapps.adsLimits.state(AdsLimits.TYPES.WORKER) === AdsLimits.STATE_DISABLED;

        const button = new cleverapps.UI.Button({
            text: `##${Messages.get("Watch")}`,
            width: styles.width,
            height: styles.height,
            disabled,
            mark: !disabled,
            type: cleverapps.styles.UI.Button.Images.button_blue,
            onClicked: function () {
                Map2d.currentMap.workers.watchAdsBonusWorker();
            }
        });

        let title = cleverapps.UI.generateOnlyText(Messages.get(text), cleverapps.styles.FONTS.BONUS_WORKER_WINDOW_BUTTON_TITLE_TEXT);

        if (timeLeft) {
            const countdown = new cleverapps.CountDownView(new cleverapps.CountDown(timeLeft, {
                onFinish: this.createListener(() => {
                    cleverapps.focusManager.display({
                        stack: true,
                        focus: "BonusWorkerWindow",
                        action: function (f) {
                            this.close();
                            new BonusWorkerWindow();
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }.bind(this)
                    });
                })
            }), {
                font: cleverapps.styles.FONTS.BONUS_WORKER_WINDOW_BUTTON_TITLE_TEXT
            });

            title = new cleverapps.Layout([title, countdown], {
                direction: cleverapps.UI.VERTICAL
            });
        }

        cleverapps.UI.fitToBox(title, {
            width: button.width,
            height: title.height
        });

        return new cleverapps.Layout([button, title], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createContent: function () {
        const animation = this.createAnimation();

        const info = this.createInfoBlock();
        const actions = this.createActionBlock();

        return new cleverapps.Layout([animation, info, actions], {
            direction: cleverapps.UI.VERTICAL,
            padding: cleverapps.styles.BonusWorkerWindow.padding
        });
    },

    createAnimation: function () {
        const styles = cleverapps.styles.BonusWorkerWindow.animation;

        const buyed = this.state === BonusWorkerWindow.STATE_BUYED;

        let plus;

        if (!buyed) {
            plus = cleverapps.UI.generateImageText("+", cleverapps.styles.FONTS.BONUS_WORKER_PLUS_TEXT);
        }

        const leftWorkers = new cleverapps.Layout([this.createOneWorker(0), this.createOneWorker(1)].map((worker, index, workers) => {
            worker.setScaleX(styles.leftWorkers.reverse ? -1 : 1);
            worker.setLocalZOrder(styles.leftWorkers.reverse ? workers.length - index : 0);
            return worker;
        }), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.leftWorkers.margin
        });

        const rightWorkers = new cleverapps.Layout([this.createOneWorker(2)], {
            direction: cleverapps.UI.HORIZONTAL
        });

        const workersAnimation = new cleverapps.Layout([leftWorkers, plus, rightWorkers].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });

        leftWorkers.children.forEach((child) => {
            if (child.rays) {
                child.rays.replaceParentSamePlace(workersAnimation);
            }
        });

        rightWorkers.children.forEach((child) => {
            if (child.rays) {
                child.rays.replaceParentSamePlace(workersAnimation);
            }
        });

        const current = Map2d.currentMap.workers.countRegularTotal();
        const animationDetails = new WorkersGain(current, this.state === BonusWorkerWindow.STATE_BUYED ? current : current + 1);

        return new cleverapps.Layout([workersAnimation, animationDetails], {
            direction: cleverapps.UI.VERTICAL
        });
    },

    createOneWorker: function (index) {
        const animation = new cleverapps.Spine(bundles.workerwindow.jsons.product);
        let skin = cleverapps.skins.getSlot("bonusWorkerWindowSkin") || "regular";
        if (Array.isArray(skin)) {
            skin = skin[index];
        }
        if (animation.hasSkin(skin)) {
            animation.setSkin(skin);
        }
        animation.setAnimation(0, cleverapps.skins.getSlot("bonusWorkerProductAnimation") || "animation", true);

        animation.rays = StandartAnimations.rays(animation, { skin: "blue" });

        return animation;
    },

    createActionBlock: function () {
        const styles = cleverapps.styles.BonusWorkerWindow.actionBlock;

        let text, timer, buyButton, watchButton;
        switch (this.state) {
            case AdsLimits.STATE_UNAVAILABLE:
            case AdsLimits.STATE_NOT_LOADED:
            case AdsLimits.STATE_DISABLED:
                buyButton = this.createBuyButton();
                break;

            case AdsLimits.STATE_LIMITED:
                buyButton = this.createBuyButton(Product.FormatTimePeriod(Workers.BONUS_WORKER_PERIOD, true).title);
                buyButton.setAnchorPoint(0.5, 1);
                watchButton = this.createWatchButton("TileShop.tile.leftTime", cleverapps.adsLimits.getLimitLeftTime(AdsLimits.TYPES.WORKER));
                watchButton.setAnchorPoint(0.5, 1);
                break;

            case AdsLimits.STATE_READY:
                buyButton = this.createBuyButton(Product.FormatTimePeriod(Workers.BONUS_WORKER_PERIOD, true).title);
                watchButton = this.watchButton = this.createWatchButton(Product.FormatTimePeriod(Workers.ADS_BONUS_WORKER_PERIOD, true).title);
                break;

            case BonusWorkerWindow.STATE_BUYED:
                text = cleverapps.UI.generateOnlyText(Messages.get("BonusWorkerWindow.buy.lefttime.text"), cleverapps.styles.FONTS.BONUS_WORKER_WINDOW_INFO_TEXT);
                timer = this.createTimer();
                break;
        }

        return new cleverapps.Layout([text, timer, watchButton, buyButton].filter(Boolean), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    listBundles: function () {
        return ["workerwindow"];
    }
});

BonusWorkerWindow.STATE_BUYED = 100;

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BONUS_WORKER_WINDOW_BUTTON_TITLE_TEXT: {
        size: 38,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BONUS_WORKER_WINDOW_TIMER_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    },

    BONUS_WORKER_WINDOW_INFO_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BONUS_WORKER_PLUS_TEXT: {
        name: "big_digits",
        size: 90,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.BonusWorkerWindow = {
    padding: {
        top: 50
    },

    infoBlock: {
        width: 720,
        height: 250
    },

    animation: {
        leftWorkers: {
            reverse: true,
            margin: -40
        }
    },

    actionBlock: {
        margin: 40
    },

    timer: {
        iconOffsetX: 30,

        width: 320,
        height: 85,

        text: {
            x: 15,
            y: 2
        }
    },

    button: {
        margin: 10,
        width: 380,
        height: 130
    }
};
